module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var types = [{name: 'Custom', value:'custom'}, {name: 'Screen - Medium', value:'medium'},
    {name: 'Screen - Large', value:'large'}, {name: 'Screen - Small', value:'small'},
    {name: 'Print - Letter', value:'letter'}, {name: 'Print - Legal', value:'legal'},
    {name: 'Print - Executive', value:'executive'}, {name: 'Print - DIN A4', value:'a4'},
    {name: 'Print - DIN A5', value:'a5'}, {name: 'Print - DIN B4', value:'b4'},
    {name: 'Print - DIN B5', value:'b5'}];
var units = ['pixel', 'inch', 'mm', 'cm', 'point'];
var u = require('util/TextUtil.js').default;

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">App Desktop Size</span></div>\r\n<div class=\"row prop-detail\">\r\n    <div class=\"row\" >\r\n        <div class=\"col-md-12\">\r\n            <select name=\"sizePreset\" id=\"sizePreset\" tabindex=\"11\">\r\n                ")
    ;  for (var i = 0; i < types.length; i++) { 
    ; __append("\r\n                    <option value=\"")
    ; __append(escapeFn(types[i].value))
    ; __append("\">")
    ; __append(escapeFn(types[i].name))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 nopadding-r subsection\">\r\n            <label class=\"prop-sublabel label-35\">Width</label>\r\n            <div>\r\n                <input type=\"text\" name=\"formWidth\" value=\"")
    ; __append(escapeFn(u.convertFromPixelToUnit(formWidth,dpi,unit)))
    ; __append("\" class=\"label-55\" tabindex=\"12\"/>\r\n            </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6 nopadding-r subsection\">\r\n            <label class=\"label-35 prop-sublabel\">Units</label>\r\n            <div>\r\n                <select name=\"unit\" id=\"unit\" tabindex=\"14\" class=\"label-55\">\r\n                    ")
    ;  for (var i = 0; i < units.length; i++) { 
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(units[i]))
    ; __append("\">")
    ; __append(escapeFn(units[i]))
    ; __append("</option>\r\n                    ")
    ;  }; 
    ; __append("\r\n                </select>\r\n            </div>\r\n        </div> \r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 nopadding-r subsection\">\r\n            <label class=\"prop-sublabel label-35\">Height</label>\r\n            <div>\r\n                <input type=\"text\" name=\"formHeight\" value=\"")
    ; __append(escapeFn(u.convertFromPixelToUnit(formHeight,dpi,unit)))
    ; __append("\" tabindex=\"13\" class=\"label-55\"/>\r\n            </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6 nopadding-r subsection\">\r\n            <label class=\"prop-sublabel label-35\">DPI</label>\r\n            <div>\r\n                <input type=\"text\" name=\"dpi\" value=\"")
    ; __append(escapeFn(dpi))
    ; __append("\" tabindex=\"15\" class=\"label-55\"/>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}